<div class="placeholder-box">
  <fa-icon icon="exclamation" size="3x" class="placeholder-icon"></fa-icon>
  <div class="placeholder-content">
    <ng-content></ng-content>
  </div>
</div>
